// @ts-check
import CalculateBonusRequest from '@bto-services/api/shared/calculate-bonus.request';
import { debounce } from '@bto-services/utils';

/**
 * Check if user is logged in
 * @returns {boolean}
 */
export function userLoggedIn() {
  return !!(APP_SETTINGS.player && APP_SETTINGS.player.token);
}

const queueCalculateBonus = () => {
  let rej = null;
  let res = null;
  let lockedRequest = false;
  let lastPlaceModel = null;

  const calculateBonusFetch = (placeModel) => {
    if (rej && lockedRequest) {
      rej(new Error('Place model updated'));
    }
    if (lockedRequest) {
      lastPlaceModel = placeModel;
      return new Promise((resolve, reject) => {
        res = resolve;
        rej = reject;
      });
    }
    lockedRequest = true;
    const calculateBonusRequest = new CalculateBonusRequest(placeModel);
    return calculateBonusRequest.execute().finally(() => {
      setTimeout(() => {
        lockedRequest = false;
        const localRej = rej;
        const localRes = res;
        if (lastPlaceModel) {
          calculateBonusFetch(lastPlaceModel).then((resp) => localRes(resp)).catch(err => localRej(err));
        }
        rej = null;
        res = null;
        lastPlaceModel = null;
      }, 2500);
    });
  };
  return calculateBonusFetch;
}

export const fetchCalculateBonus = queueCalculateBonus();

function btoUserRef(key, cb) {
  if (typeof btoUser === 'undefined') {
    return;
  }
  let val = btoUser[key];
  Object.defineProperty(btoUser, key, {
    set(token) {
      val = token;
      if (cb) {
        cb();
      }
    },
    get() {
      return val;
    },
    enumerable: true,
  });
}

/**
 * Reactivly watch for changes on global btoUser object if exists
 * And apply callback on it's change
 * @param {()=>void} cb - callback function
 */
export function watchBtoUser(cb) {
  let debouncedCb = debounce(cb, 1);
  ['token', 'id', 'language', 'currency'].forEach(k => {
    btoUserRef(k, debouncedCb);
  });
}
